import type { Product, ProductSetupConfig } from "./types";

/**
 * Registry of all merchant-setup-guide products. Adding a product is two
 * steps:
 *   1. Add the value to the merchant_setup_product enum in CRDB (alter
 *      type migration).
 *   2. Register the product config here via registerProduct().
 *
 * Disputes is registered in `redo/merchant/app/src/setup-guide/products/
 * disputes/register.ts`.
 */
const registry: Partial<Record<Product, ProductSetupConfig>> = {};

export function registerProduct(config: ProductSetupConfig): void {
  if (registry[config.product]) {
    throw new Error(
      `setup-guide: product ${config.product} is already registered`,
    );
  }
  registry[config.product] = config;
}

export function getProductConfig(product: Product): ProductSetupConfig | null {
  return registry[product] ?? null;
}

export function getRegisteredProducts(): Product[] {
  return Object.keys(registry) as Product[];
}

/**
 * Test-only helper to reset the registry between tests. Not exported via
 * a public barrel — only for use within registry tests.
 */
export function _resetRegistryForTesting(): void {
  for (const key of Object.keys(registry)) {
    delete registry[key as Product];
  }
}
